import React, { useEffect } from "react";
import { Container, Stack, Text, Title } from "@mantine/core";
import AppNavBar from "../components/AppNavBar";
import { useObjectStore } from "../zustand/objects";
import { getStoryboardChromeTheme, pageLayoutProps } from "../styleFile";
import { CHROME_HEADER_HEIGHT } from "../utils/uiChromeTokens";

const ProfileSettingsPage = () => {
  const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);
  const isDark = viewportThemeOverride === "dark";
  const sbTheme = getStoryboardChromeTheme(isDark);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    document.body.setAttribute("data-editor-theme", isDark ? "dark" : "light");
    return () => document.body.removeAttribute("data-editor-theme");
  }, [isDark]);

  return (
    <>
      <AppNavBar pageName="Profile" />
      <Container
        {...pageLayoutProps}
        style={{ backgroundColor: sbTheme.mainBg, minHeight: `calc(100vh - ${CHROME_HEADER_HEIGHT}px)` }}
      >
        <Stack gap="sm" maw={480}>
          <Title order={3} c={sbTheme.headlineColor}>
            Profile
          </Title>
          <Text size="xs" c={sbTheme.mutedTextColor}>
            Profile settings will appear here.
          </Text>
        </Stack>
      </Container>
    </>
  );
};

export default ProfileSettingsPage;
